 import { Button, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DEFAULT_ROUTE } from "constants/route";
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { vipStyle } from "utils/common";
import { useBSScreenBreak, useScreenWidth } from "../../hooks";

export const LinkButton = ({ onClick, text, style = {} }) => {
  return (
    <div
      className="cmp-action-card cmp-action-card--outlink cmp-action-card--elevation-1 "
      style={{
        margin: "0px !important",
        cursor: "pointer",
        display: "flex",
        ...style
      }}
      onClick={() => onClick && onClick()}>
      <a
        data-analytics-click-id="ActionCardClickableCard1"
        data-analytics-text="Healthcare financing_View claims statement"
        // href={link}
        target="_self">
        <div className="cmp-title headline-5" aria-label="View claims statement" role="region">
          <span className="cmp-button__text" style={{ textAlign: "left" }}>
            {text}
          </span>
          {/* <span className="icons_space icon-dls-arrow-right"></span> */}
          <span className=" icon-dls-arrow-right"></span>
        </div>
      </a>
    </div>
  );
};

export const HomeButton = ({ onClick, type = "button", text = "Back to contact us" }) => {
  const navigate = useNavigate();

  const goHome = (e) => {
    e.preventDefault();
    navigate(DEFAULT_ROUTE);
  };

  const handleClick = () => onClick && onClick();

  return (
    // <Button
    //   className="btn left-button cmp-button pbs-style--primary rounded-pill"
    //   onClick={onClick ? handleClick : goHome}
    // >
    //   Back to Contact Us
    // </Button>
    <button
      // className="cmp-button cmp-button--primary button-default button-medium moveNext"
      className="cmp-button 
        button-default
        cmp-button--primary
        left-button 
        pbs-style--primary rounded-pill
        mobile-w-100
        "
      style={{ maxWidth: "100%" }}
      // type={type}
      onClick={onClick ? handleClick : goHome}
      type={type}>
      <span
        className="iconButton-label cmp-button__text"
        data-guide-button-label="true"
        style={{ margin: 5 }}>
        {text}
      </span>
    </button>
  );
};

export const BackButton = ({ onClick }) => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  const handleClick = () => onClick();

  return (
    <button
      className="cmp-button cmp-button--primary button-default button-medium left-button mobile-w-100"
      style={{ alignItems: "center" }}
      onClick={onClick ? handleClick : goBack}
      // Need to define type to avoid form validation
      type={"button"}>
      <span
        className="iconButton-icon icons_space icon-dls-arrow-left"
        style={{ marginTop: -1, paddingLeft: 10 }}
      />
      <span
        className="iconButton-label cmp-button__text"
        data-guide-button-label="true"
        style={{ margin: 5, marginLeft: -10 }}>
        Back
      </span>
    </button>
  );
};

// Left side button
export const BackButton2 = ({ onClick }) => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);
  const handleClick = () => onClick();

  return (
    <button
      className="cmp-button cmp-button--primary button-default button-medium left-button mobile-w-100"
      style={{ alignItems: "center" }}
      onClick={onClick ? handleClick : goBack}
      // Need to define type to avoid form validation
      type={"button"}>
      {/*<span
        className="iconButton-icon icons_space icon-dls-arrow-left"
        style={{ marginTop: -1, paddingLeft: 10 }}
      />*/}
      <span className="iconButton-label cmp-button__text" data-guide-button-label="true">
        Back
      </span>
    </button>
  );
};

export const Disclaimer = ({ checked, onChange }) => {
  return (
    <fieldset className="cmp-form-options cmp-form-options--radio cta-bar__inner">
      <label className="cmp-form-options__field-label d-flex" style={{ flexWrap: "nowrap" }}>
        <input
          className="cmp-form-options__field cmp-form-options__field--checkbox"
          id="coverCheckbox"
          type="checkbox"
          checked={checked}
          onChange={() => onChange && onChange()}
        />

        <div className="cmp-form-options__field-description" style={{ width: "100%" }}>
          <p style={{ marginBottom: 0 }}>
            I confirm that the information provided is correct. I have read and accepted the&nbsp;
            <a href={window.termsAndConditionsLink} target="_blank">
              Terms and Conditions
            </a>
            .
          </p>
        </div>
      </label>
    </fieldset>
  );
};

export const Disclaimer2 = ({
  checked,
  onChange,
  text = "I confirm that the information provided is correct. I have read and accepted the",
  linkText=  null
}) => {
  // const bsScreenBreak = useBSScreenBreak();

  return (
    <fieldset
      className={`cmp-form-options cmp-form-options--radio cta-bar__inner 
      mobile-w-100
       `}
      /*${
                bsScreenBreak === "xs" || bsScreenBreak === "sm" ? "w-100" : ""
              }*/
      // style={{ height: 58 }}
    >
      <label
        className="cmp-form-options__field-label d-flex mb-sm-3 mb-md-0"
        style={{ flexWrap: "nowrap" }}>
        <input
          className="cmp-form-options__field cmp-form-options__field--checkbox"
          id="coverCheckbox"
          type="checkbox"
          checked={checked}
          onChange={() => onChange && onChange()}
        />

        <div
          className="cmp-form-options__field-description"
          style={{ width: "100%", paddingTop: 0 }}>
          <p style={{ marginBottom: 0, lineHeight: "initial" }}>
            {text}
            {linkText && (
              <>
                &nbsp;
                <a href={window.termsAndConditionsLink} target="_blank">
                  {linkText}
                </a>
                .
              </>
            )}
          </p>
        </div>
      </label>
    </fieldset>
  );
};

export const Radio = ({ id, value, onChange, checked, label, disabled=false, needCol=true }) => {
  // const [val, setVal] = useState(value);

  const selectedClass = checked ? "guideRadioSelected" : "";
  console.log("checked", checked, id);
  const disabledClass = disabled ? "input-disabled" : "";
  const colClass = needCol ? "col-12" : "";

  return (
    <div
      className={`guideFieldWidget guideFieldVerticalAlignment ${colClass} XfaCheckBox`}
      data-original-title=""
      title=""
      onClick={() => {
        onChange && onChange({ target: { value } });
      }}>
      <label
        className={`guideRadio guideRadioButtonItem afRadioButtonItem radiotopup topup-type ${selectedClass} ${disabledClass}`}
        data-id={`${id}`}
        name="guideContainer-rootPanel-progressPanel-step1-guideradiobutton___jqName"
        tabIndex="0"
        aria-label="PayNow QR"
        aria-required="true"
        aria-checked="false"
        placeholder=""
        data-original-title=""
        title="">
        <span className="guideRadioInput">
          <input
            type="radio"
            id={`guideContainer-rootPanel-progressPanel-step1-guideradiobutton__-1_widget ${id}`}
            data-element-name={`${id}`}
            name={`${id}`}
            value={value}
            checked={checked}
            // aria-required="true"
            style={{ position: "relative" }}
            element-name={`${id}`}
            onChange={() => onChange && onChange({ target: { value } })}
            disabled={disabled}
          />
          <span className="guideRadioControl"></span>
        </span>
        <span className="guideRadioLabel">{label}</span>
      </label>
    </div>
  );
};

export const RadioList = ({ children, style = {} }) => {
  return (
    <div
      className="cmp-webf guideFieldNode guideCheckBox radiotopup topup-type captionErrorBelowLabelLayout af-field-empty"
      style={style}>
      <div className="guideRadioButtonGroupItems row" style={{}}>
        {children}
      </div>
    </div>
  );
};

export const NextButton = ({ disabled = false, type = "button", text = "Next" }) => {
  return (
    <>
      {disabled ? (
        <button
          className={`cmp-button cmp-button--primary button-default button-medium moveNext mobile-w-100`}
          type={type}
          disabled="disabled">
          <span
            className="iconButton-label cmp-button__text"
            data-guide-button-label="true"
            style={{ margin: 5 }}>
            {text}
          </span>
          <span
            className="iconButton-icon icons_space icon-dls-arrow-right"
            style={{ marginTop: -1 }}></span>
        </button>
      ) : (
        <button
          className="cmp-button cmp-button--primary button-default button-medium moveNext mobile-w-100"
          type={type}>
          <span
            className="iconButton-label cmp-button__text"
            data-guide-button-label="true"
            style={{ margin: 5 }}>
            {text}
          </span>
          <span
            className="iconButton-icon icons_space icon-dls-arrow-right"
            style={{ marginTop: -1 }}
          />
        </button>
      )}
    </>
  );
};

export const NextButton2 = ({ disabled = false, type = "button", text = "Next", onClick }) => {
  return (
    <>
      {disabled ? (
        <button
          className={`cmp-button cmp-button--primary button-default button-medium moveNext mobile-w-100`}
          type={type}
          disabled="disabled">
          <span className="iconButton-label cmp-button__text" data-guide-button-label="true">
            {text}
          </span>
          <span
            className="iconButton-icon icons_space icon-dls-arrow-right"
            style={{ marginTop: -6 }}></span>
        </button>
      ) : (
        <button
          onClick={() => onClick && onClick()}
          className="cmp-button cmp-button--primary button-default button-medium moveNext mobile-w-100"
          type={type}>
          <span className="iconButton-label cmp-button__text" data-guide-button-label="true">
            {text}
          </span>
          <span
            className="iconButton-icon icons_space icon-dls-arrow-right"
            style={{ marginTop: -6 }}
          />
        </button>
      )}
    </>
  );
};

export const CommonButton = ({ type = "button", text, onClick, leftOrRight, className }) => {
  return (
    <>
      <button
        // className="cmp-button cmp-button--primary button-default button-medium moveNext"
        className={`mobile-w-100 cmp-button cmp-button--primary button-default button-medium ${className}
        ${leftOrRight === "left" ? "left-button-white" : "moveNext"}`}
        type={type}
        onClick={onClick}>
        <span
          className="iconButton-label cmp-button__text"
          data-guide-button-label="true"
          style={{ margin: 5 }}>
          {text}
        </span>
      </button>
    </>
  );
};

export const CommonButton2 = ({ type = "button", text, onClick, whiteOrFill, className, disabled=false }) => {
  return (
    <>
      <button
        // className="cmp-button cmp-button--primary button-default button-medium moveNext"
        className={`mobile-w-100 cmp-button cmp-button--primary button-default button-medium ${className}
        ${whiteOrFill === "white" ? "left-button-white" : "moveNext"}`}
        type={type}
        onClick={onClick}
        disabled={disabled}
      >
        <span className="iconButton-label cmp-button__text" data-guide-button-label="true">
          {text}
        </span>
      </button>
    </>
  );
};

export const InputText = React.forwardRef(
  (
    {
      label = null,
      type = "text",
      placeholder = "",
      value,
      onChange,
      isInvalid = false,
      errorMessage = "",
      readOnly = false,
      onClick = () => {},
      icon = null,
      iconStyle = {},
      iconOnClick = () => {},
      maxLength = null,
      // cursor = "text",
      style={},
      iconComponent = null,
      disabled = false,
      footNote = null
    },
    ref
  ) => {
    return (
      <>
        <div>
          {label != null && (
            <div className="guideFieldLabel top">
              <div className="label-container">
                <label htmlFor="" id="" style={{ fontFamily: "Montserrat" }}>
                  {label}
                </label>
              </div>
            </div>
          )}
          <div className={`guidetextbox guidefield input-text ${isInvalid ? "input-error" : ""}`}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <input
                type={type}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                readOnly={readOnly}
                onClick={onClick}
                ref={ref}
                maxLength={maxLength}
                style={{ ...style }}
                disabled={disabled}
                className={"text-input"}
              />
              {icon && (
                <div onClick={iconOnClick}>
                  {/* icon-general-calendar-default */}
                  <i
                    className={`icon-illustrative ${icon}`}
                    aria-hidden="true"
                    style={{ position: "relative", left: -45, ...iconStyle }}></i>
                </div>
              )}
              {iconComponent}
            </div>
          </div>
          <div className="input-error-msg" style={{ display: isInvalid ? "block" : "none" }}>
            {errorMessage}
          </div>
          {footNote && <span style={{ color: "gray", fontStyle: "italic" }}>{footNote}</span>}
        </div>
      </>
    );
  }
);

export const DropDown = ({
  label = "Combo Box",
  isInvalid = false,
  errorMessage = null,
  items,
  value,
  onChange
}) => {
  const [valueText, setValueText] = useState("");

  useEffect(() => {
    const item = items.find((i) => i.id === value);
    setValueText(item ? item.text : "");
  }, [items, value]);

  const CustomInput = React.forwardRef(({ onClick }, ref) => (
    <InputText
      value={valueText}
      onClick={onClick}
      readOnly
      // cursor="pointer"
      isInvalid={isInvalid}
      iconComponent={
        <span className="icon-drop-down-arrow" onClick={onClick}>
          &nbsp;
        </span>
      }
    />
  ));

  return (
    <>
      <div>
        {label != null && (
          <div className="guideFieldLabel top">
            <div className="label-container">
              <label htmlFor="" id="" style={{ fontFamily: "Montserrat" }}>
                {label}
              </label>
            </div>
          </div>
        )}
        <div className={`guidetextbox guidefield input-text ${isInvalid ? "input-error" : ""}`}>
          {/* <div style={{ display: "flex", alignItems: "center" }}> */}
          <Dropdown
            onSelect={(value) => {
              onChange({ target: { value } });
            }}
            defaultValue={""}
            variant="success">
            <Dropdown.Toggle as={CustomInput} id="dropdown-custom-components" />

            <Dropdown.Menu
              style={{
                width: "100%",
                paddingLeft: 16,
                paddingRight: 16,
                border: "1px solid #9bbab8",
                height: 200,
                overflowY: "scroll"
              }}>
              {/* <Dropdown.Item value="">None</Dropdown.Item> */}
              {items.map((item, index) => (
                <Dropdown.Item
                  eventKey={item.id}
                  key={item.id}
                  style={{
                    borderBottom: index !== items.length - 1 ? "1px solid #80808045" : "",
                    paddingTop: 10,
                    paddingBottom: 10,
                    fontWeight: value === item.id ? 600 : 400
                  }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between"
                    }}>
                    <div>{item.text}</div>
                    {value === item.id && <div className="icon-drop-down-tick"></div>}
                  </div>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {/* </div> */}
        <div className="input-error-msg" style={{ display: isInvalid ? "block" : "none" }}>
          {errorMessage}
        </div>
      </div>
    </>
  );
};

export const SeparatorLine = ({ style }) => {
  return (
    <div class="separator " style={style}>
      <div class="cmp-separator">
        <hr class="cmp-separator__horizontal-rule cmp-separator--dotted separator-dotted-fix" />
      </div>
    </div>
  );
};

export const Tooltip = ({ text, style = {} }) => {
  const [showModal, setShowModal] = useState(false);
  const isMobile = window.innerWidth < 992;
  const clk = () => {
    if (isMobile) {
      // alert(text);
      setShowModal(true);
    }
  };
  return (
    <>
      <Modal
        show={showModal}
        // onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered>
        <div style={{ width: "100%", border: "0px solid red" }}>
          <i
            _ngcontent-wwv-c123=""
            aria-hidden="true"
            class="icon-dls-close-outline"
            onClick={() => setShowModal(false)}></i>
        </div>
        <Modal.Body>
          <p>{text}</p>
        </Modal.Body>
      </Modal>
      <div class="cmp-tooltip" style={style} onClick={clk}>
        <div class="cmp-tooltip-overlay-bg"></div>
        <div class="cmp-tooltip-wrapper">
          <i class="icon-dls-info-outline"></i>
          <div class={`cmp-tooltip-wrapper-popup`}>
            <div style={{ textAlign: "left" }}>{text}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export const DataLabel = ({ label, data, extra = null }) => {
  return (
    <div className="mb-3">
      {label}
      <br />
      <span style={{ fontWeight: 600 }}>{data}</span>
      {extra && <div style={{ fontWeight: 600 }}>{extra}</div>}
    </div>
  );
};

export const Instruction = ({ children }) => {
  return (
    <div class="instructions instructions-mod">
      <div class="instructions-content">{children}</div>
    </div>
  );
};

export const CardButton = ({ icon, text, subText, onClick }) => {
  return (
    <>
      <div
        class="clickable-card aem-GridColumn aem-GridColumn--default--4"
        style={{ height: "100%" }}>
        <div
          ref={(n) => vipStyle(n, { "margin-left": 0, "margin-right": 0 })}
          class="cmp-action-card cmp-action-card--outlink cmp-action-card--elevation-1 ">
          <a
            data-analytics-click-id="RelatedResourcesSectionClickableCard1"
            data-analytics-text="Call us"
            href="#"
            onClick={onClick}
            // href="/member/contact-us/call-us"
            // target="_self"
            style={{ paddingBottom: 0 }}>
            <i className={`icon-illustrative icon-illustrative ${icon}`} aria-hidden="true"></i>
            <div class="cmp-title headline-5" aria-label="Call us" role="region">
              <span class="cmp-button__text">{text}</span>
              <span class="icons_space icon-dls-arrow-right"></span>
            </div>
            <div>
              <p style={{ marginBottom: 0 }}>{subText}</p>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export const StepperBar = ({ title, items }) => {
  const complete =
    "form-stepper__step form-stepper__step--stepped af-widget-itemnav af-widget-itemnav- form-stepper__step--previous";
  const current =
    "form-stepper__step form-stepper__step af-widget-itemnav af-widget-itemnav- form-stepper__step--current form-stepper__step--stepped";
  const next = "form-stepper__step form-stepper__step af-widget-itemnav af-widget-itemnav-";

  return (
    <div class="guideLayout row guideWizardLayout cmp-progress-stepper" style={{ width: "80%" }}>
      <div class="col-md-12 clearfix" style={{ padding: 0 }}>
        <div class="fluid-container form-header dark-mode">
          <div class="anchor-content aem-Grid aem-Grid--default--12">
            <div
              class="anchor-content aem-GridColumn aem-GridColumn--default--12 progress-bar"
              style={{ padding: 12 }}>
              <h5 class="title__text">{title}</h5>

              {/* <div class="mobile-form-stepper">
                <div
                  // class="mobile-form-stepper__current-step-display"
                  class="mobile-form-stepper__current-step-display mobile-form-stepper__current-step-display-active"
                  id="mob-menu-toggle-btn"
                >
                  <div class="mobile-form-stepper__current-step-count">
                    <span class="mobile-form-stepper__step-indicator font-size-5">
                      <span class="">1</span>
                    </span>
                    <span class="mobile-form-stepper__current-step-suffix">
                      {" "}
                      of{" "}
                    </span>
                    &nbsp;
                    <span class="mobile-form-stepper__current-step-total-count">
                      {" "}
                      4{" "}
                    </span>
                  </div>
                  <div class="mobile-form-stepper__current-step-separator-vertical"></div>
                  <div class="mobile-form-stepper__current-step-title-bar">
                    <span class="mobile-form-stepper__current-step-title font-semi-bold">
                      Main Form
                    </span>
                    <button
                      class="mobile-form-stepper__current-step-dropdown-cta"
                      data-original-title=""
                      title=""
                    >
                      <i
                        class="icon-dls-arrow-down"
                        id="mob-menu-toggle-btn-icon"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                  <div
                    class="mobile-form-stepper__dropdown elevation-3"
                    style={{ display: "none" }}
                    id="mob-menu-dropdown"
                  >
                    <ul class="mobile-form-stepper__steps">
                      <li
                        class="mobile-form-stepper__step mobile-form-stepper__step--current mobile-form-stepper__step--stepped"
                        title="Main Form"
                        data-path="/content/forms/af/web/dsd/ucd/jcr:content/guideContainer/rootPanel/items/progressPanel/items/step1"
                        data-index="0"
                        aria-controls="guideContainer-rootPanel-progressPanel-step1___guide-item"
                        data-selected="true"
                        aria-disabled="false"
                        style={{ pointerEvents: "none" }}
                      >
                        <span class="mobile-form-stepper__step-indicator font-size-5">
                          1
                        </span>
                        <span class="mobile-form-stepper__step-label-wrapper">
                          <span
                            class="mobile-form-stepper__step-label"
                            data-guide-prop="title"
                            data-guide-id="guideContainer-rootPanel-progressPanel-step1__"
                          >
                            Main Form
                          </span>
                          <i
                            class="mobile-form-stepper__step-icon icon-dls-tick-outline"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </li>
                      <div class="mobile-form-stepper__vertical-line"></div>

                      <li
                        class="mobile-form-stepper__step mobile-form-stepper__step"
                        title="Mobile OTP"
                        data-path="/content/forms/af/web/dsd/ucd/jcr:content/guideContainer/rootPanel/items/progressPanel/items/step2"
                        data-index="1"
                        aria-controls="guideContainer-rootPanel-progressPanel-step2___guide-item"
                        aria-disabled="true"
                        // style={{ pointerEvents: "none" }}
                      >
                        <span class="mobile-form-stepper__step-indicator font-size-5">
                          2
                        </span>
                        <span class="mobile-form-stepper__step-label-wrapper">
                          <span
                            class="mobile-form-stepper__step-label"
                            data-guide-prop="title"
                            data-guide-id="guideContainer-rootPanel-progressPanel-step2__"
                          >
                            Mobile OTP
                          </span>
                          <i
                            class="mobile-form-stepper__step-icon icon-dls-tick-outline"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </li>
                      <div class="mobile-form-stepper__vertical-line"></div>

                      <li
                        class="mobile-form-stepper__step mobile-form-stepper__step"
                        title="Email OTP"
                        data-path="/content/forms/af/web/dsd/ucd/jcr:content/guideContainer/rootPanel/items/progressPanel/items/panel1625114416293"
                        data-index="2"
                        aria-controls="guideContainer-rootPanel-progressPanel-panel1625114416293___guide-item"
                        aria-disabled="true"
                        style={{ pointerEvents: "none" }}
                      >
                        <span class="mobile-form-stepper__step-indicator font-size-5">
                          3
                        </span>
                        <span class="mobile-form-stepper__step-label-wrapper">
                          <span
                            class="mobile-form-stepper__step-label"
                            data-guide-prop="title"
                            data-guide-id="guideContainer-rootPanel-progressPanel-panel1625114416293__"
                          >
                            Email OTP
                          </span>
                          <i
                            class="mobile-form-stepper__step-icon icon-dls-tick-outline"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </li>
                      <div class="mobile-form-stepper__vertical-line"></div>

                      <li
                        class="mobile-form-stepper__step mobile-form-stepper__step"
                        title="Acknowledgement"
                        data-path="/content/forms/af/web/dsd/ucd/jcr:content/guideContainer/rootPanel/items/progressPanel/items/panel1625114822535"
                        data-index="3"
                        aria-controls="guideContainer-rootPanel-progressPanel-panel1625114822535___guide-item"
                        aria-disabled="true"
                        style={{ pointerEvents: "none" }}
                      >
                        <span class="mobile-form-stepper__step-indicator font-size-5">
                          4
                        </span>
                        <span class="mobile-form-stepper__step-label-wrapper">
                          <span
                            class="mobile-form-stepper__step-label"
                            data-guide-prop="title"
                            data-guide-id="guideContainer-rootPanel-progressPanel-panel1625114822535__"
                          >
                            Acknowledgement
                          </span>
                          <i
                            class="mobile-form-stepper__step-icon icon-dls-tick-outline"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}

              <div class="form-stepper">
                <ul
                  class="form-stepper__steps wizard-navigators  "
                  id="guideContainer-rootPanel-progressPanel___guide-item-nav-container "
                  data-guide-panel-edit="reorderItems"
                  role="tablist">
                  {items.map((item, index) => (
                    <li
                      // class="form-stepper__step form-stepper__step--stepped af-widget-itemnav af-widget-itemnav- form-stepper__step--previous"
                      className={item.complete ? complete : item.current ? current : next}
                      title="Main Form"
                      // data-path="/content/forms/af/web/dsd/ucd/jcr:content/guideContainer/rootPanel/items/progressPanel/items/step1"
                      role="tab"
                      data-index="0"
                      aria-controls="guideContainer-rootPanel-progressPanel-step1___guide-item"
                      tabindex="0"
                      data-selected="false"
                      aria-disabled="false"
                      style={{ pointerEvents: "none" }}>
                      <span
                        class="form-stepper__step-indicator font-size-5 "
                        data-guide-toggle="tab">
                        <span>{index + 1}</span>
                      </span>
                      <span
                        class="form-stepper__step-label font-size-5"
                        data-guide-prop="title"
                        data-guide-id="guideContainer-rootPanel-progressPanel-step1__">
                        {item.text}
                      </span>
                    </li>
                  ))}

                  {/* 
                    // class="form-stepper__step form-stepper__step--stepped af-widget-itemnav af-widget-itemnav- form-stepper__step--previous"
                    // class="form-stepper__step form-stepper__step af-widget-itemnav af-widget-itemnav- form-stepper__step--current form-stepper__step--stepped"
                    // class="form-stepper__step form-stepper__step af-widget-itemnav af-widget-itemnav-"

                  // <li
                  //   class="form-stepper__step form-stepper__step--stepped af-widget-itemnav af-widget-itemnav- form-stepper__step--previous"
                  //   title="Main Form"
                  //   // data-path="/content/forms/af/web/dsd/ucd/jcr:content/guideContainer/rootPanel/items/progressPanel/items/step1"
                  //   role="tab"
                  //   data-index="0"
                  //   aria-controls="guideContainer-rootPanel-progressPanel-step1___guide-item"
                  //   tabindex="0"
                  //   data-selected="false"
                  //   aria-disabled="false"
                  //   style={{ pointerEvents: "none" }}
                  // >
                  //   <span
                  //     class="form-stepper__step-indicator font-size-5 "
                  //     data-guide-toggle="tab"
                  //   >
                  //     <span>1</span>
                  //   </span>
                  //   <span
                  //     class="form-stepper__step-label font-size-5"
                  //     data-guide-prop="title"
                  //     data-guide-id="guideContainer-rootPanel-progressPanel-step1__"
                  //   >
                  //     Main Form
                  //   </span>
                  // </li>

                  // <li
                  //   class="form-stepper__step form-stepper__step af-widget-itemnav af-widget-itemnav- form-stepper__step--current form-stepper__step--stepped"
                  //   title="Main Form"
                  //   // data-path="/content/forms/af/web/dsd/ucd/jcr:content/guideContainer/rootPanel/items/progressPanel/items/step1"
                  //   role="tab"
                  //   data-index="0"
                  //   aria-controls="guideContainer-rootPanel-progressPanel-step1___guide-item"
                  //   tabindex="0"
                  //   style={{ pointerEvents: "none" }}
                  //   data-selected="true"
                  //   aria-disabled="false"
                  // >
                  //   <span
                  //     class="form-stepper__step-indicator font-size-5 "
                  //     data-guide-toggle="tab"
                  //   >
                  //     <span>1</span>
                  //   </span>
                  //   <span
                  //     class="form-stepper__step-label font-size-5"
                  //     data-guide-prop="title"
                  //     data-guide-id="guideContainer-rootPanel-progressPanel-step1__"
                  //   >
                  //     Main Form
                  //   </span>
                  // </li>

                  // <li
                  //   class="form-stepper__step form-stepper__step af-widget-itemnav af-widget-itemnav-"
                  //   title="Mobile OTP"
                  //   // data-path="/content/forms/af/web/dsd/ucd/jcr:content/guideContainer/rootPanel/items/progressPanel/items/step2"
                  //   role="tab"
                  //   data-index="1"
                  //   aria-controls="guideContainer-rootPanel-progressPanel-step2___guide-item"
                  //   tabindex="0"
                  //   style={{ pointerEvents: "none" }}
                  //   data-selected="false"
                  //   aria-disabled="true"
                  // >
                  //   <span
                  //     class="form-stepper__step-indicator font-size-5 "
                  //     data-guide-toggle="tab"
                  //   >
                  //     <span>2</span>
                  //   </span>
                  //   <span
                  //     class="form-stepper__step-label font-size-5"
                  //     data-guide-prop="title"
                  //     data-guide-id="guideContainer-rootPanel-progressPanel-step2__"
                  //   >
                  //     Mobile OTP
                  //   </span>
                  // </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AccordionButton = ({ title, children }) => {
  const [expended, setExpended] = useState(false);

  return (
    <>
      <div className={"cmp-accordion__item"}>
        <h3 class="cmp-accordion__header">
          <button
            id="accordion-45f7b4c00e-item-1ab7018061-button"
            // class="cmp-accordion__button"
            className={`cmp-accordion__button ${expended ? "cmp-accordion__button--expanded" : ""}`}
            aria-controls="accordion-45f7b4c00e-item-1ab7018061-panel"
            data-cmp-hook-accordion="button"
            aria-label="Save more with CPF"
            aria-expanded="false"
            eventlistenerattached="true"
            onClick={() => setExpended(!expended)}>
            <span class="cmp-accordion__title" aria-label="Save more with CPF">
              {title}
            </span>
            <span class="cmp-accordion__icon"></span>
          </button>
        </h3>
        <div
          data-cmp-hook-accordion="panel"
          id="accordion-45f7b4c00e-item-1ab7018061-panel"
          // class="cmp-accordion__panel cmp-accordion__panel--expanded"
          className={`cmp-accordion__panel ${
            expended ? "cmp-accordion__panel--expanded" : "cmp-accordion__panel--hidden"
          }`}
          aria-label="Save more with CPF"
          aria-labelledby="accordion-45f7b4c00e-item-1ab7018061-button"
          aria-hidden="false">
          <div class="container responsivegrid" style={{ padding: 0 }}>
            <div id="container-1ab7018061" class="no-animation cmp-container">
              <div class="aem-Grid aem-Grid--9 aem-Grid--default--9  base-print-flex base-print-grid">
                <div class="text aem-GridColumn--default--9 aem-GridColumn">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const ALink = ({ href, onClick, style, children }) => {
  return (
    <a
      className="cmp-button cmp-button--link"
      style={style}
      href={href}
      onClick={onClick}
      target="_self">
      <span className="cmp-button__text">{children}</span>
    </a>
  );
};

export const BulletList = ({ items }) => {
  const listStyle = { listStyle: "disc" };

  return (
    <ul>
      {items.map((item) => (
        <li style={listStyle}>{item}</li>
      ))}
    </ul>
  );
};

export const BlockSeparator = () => {
  return (
    <div
      class="separator aem-GridColumn--default--none aem-GridColumn aem-GridColumn--default--8 aem-GridColumn--offset--default--0 animation-wrapper"
      style={{ height: "auto" }}>
      <div class="separator cmp-margin-bottom animation-element slide-up in-view reset-animation animation-display">
        <div class="cmp-separator">
          <hr class="cmp-separator__horizontal-rule cmp-separator--section" />
        </div>
      </div>
    </div>
  );
};

export const AlertPanel = ({ children }) => {
  return (
    <div class="alert cmp-alert cmp-webf">
      <div
        class="guideFieldNode guideTextDraw alertCoverPageMaintenance alertRIGFormMaintenance guideStaticText af-field-filled"
        id="guideContainer-rootPanel-panel-panel-panel-alert__"
        data-guide-view-bind="guideContainer-rootPanel-panel-panel-panel-alert__"
        data-disabled="false">
        <div class="alerts alerts-info">
          <div class="alerts-icon">
            <span class="icon-dls-info-outline"></span>
          </div>
          <div class="alerts-body">
            <span class="alerts-body-title "></span>
            <div class="alerts-body-content">
              <p style={{ textAlign: "left", marginBottom: 0 /*fontStyle: "normal"*/, fontStyle:"normal", color: "rgb(38,38,38)" }}>
                {children}
                {/*<strong>Scheduled Maintenance</strong>: Payment using eNETS debit payment will not
                be available on 8 Jan 2023 from 3am to 6am due to scheduled maintenance by eNETS.*/}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SummaryTitle = ({ children }) => {
  return (
    <div className="instructions instructions-mod" style={{ borderRadius: "10px 10px 0 0" }}>
      <div className="instructions-content " style={{ fontWeight: 700 }}>
        {children}
      </div>
    </div>
  );
};
